import { Bouton, Champ, GrilleChamps } from '@cc/ui';
import { NOMS_COINS, PAGE_ENTIERE } from './geometrie';
import type { Coins } from './types';

export function CoinsCapture({
  coins,
  onChanger,
  apercu,
  disabled,
  largeur,
  hauteur,
}: {
  coins: Coins;
  onChanger: (coins: Coins) => void;
  apercu: string;
  disabled: boolean;
  largeur: number;
  hauteur: number;
}) {
  const changer = (i: number, axe: 'x' | 'y', valeur: string) => {
    const n = Number(valeur);
    if (!Number.isFinite(n) || n < 0 || n > 100) return;
    onChanger(coins.map((p, j) => (j === i ? { ...p, [axe]: n / 100 } : p)) as unknown as Coins);
  };
  return (
    <>
      <svg
        viewBox={`0 0 ${largeur} ${hauteur}`}
        role="img"
        aria-label="Photo originale et contour proposé"
        style={{ width: '100%', maxHeight: 300 }}
        preserveAspectRatio="xMidYMid meet"
      >
        <image href={apercu} width={largeur} height={hauteur} />
        <polygon
          points={coins.map((p) => `${p.x * largeur},${p.y * hauteur}`).join(' ')}
          fill="none"
          stroke="currentColor"
          strokeWidth={Math.max(largeur, hauteur) * 0.005}
        />
      </svg>
      <p>
        Réglez les quatre coins en pourcentage de la largeur et de la hauteur. L’original reste
        conservé.
      </p>
      <GrilleChamps>
        {coins.flatMap((p, i) =>
          (['x', 'y'] as const).map((axe) => (
            <Champ
              key={`${i}-${axe}`}
              libelle={`${NOMS_COINS[i]} : ${axe === 'x' ? 'horizontal' : 'vertical'} (%)`}
              type="number"
              min={0}
              max={100}
              step={0.1}
              value={Math.round(p[axe] * 1000) / 10}
              disabled={disabled}
              onChange={(e) => changer(i, axe, e.target.value)}
            />
          )),
        )}
      </GrilleChamps>
      <Bouton
        type="button"
        variante="secondaire"
        disabled={disabled}
        onClick={() => onChanger(PAGE_ENTIERE)}
      >
        Garder l’image entière
      </Bouton>
    </>
  );
}
